/* assets/pdp-badges-overlay.js */
(() => {
  const SELECTOR_GALLERY_SCOPE = '[data-pdp-media-gallery]';
  const SELECTOR_SOURCE =
    '[id^="ProductInfo-"] [x-labels-data].x-badges-container.x-badges-product-detail';

  // 슬라이더/스택 등 다양한 레이아웃 타겟
  const TARGET_SELECTORS = [
    // thumbnail slider (Splide)
    `${SELECTOR_GALLERY_SCOPE} .splide__slide`,
    // stacked / 2_columns wrapper
    `${SELECTOR_GALLERY_SCOPE} .product-media-item`,
    // fallback (일부 테마 구조에서 media wrapper)
    `${SELECTOR_GALLERY_SCOPE} .product-media`
  ];

  const OVERLAY_CLASS = 'pdp-media-badges-overlay';
  const OVERLAY_ATTR = 'data-pdp-media-badges-overlay';

  const getSource = () => document.querySelector(SELECTOR_SOURCE);
  const getScope = () => document.querySelector(SELECTOR_GALLERY_SCOPE);

  const getTargets = (scope) => {
    const set = new Set();
    TARGET_SELECTORS.forEach((sel) => {
      scope.querySelectorAll(sel.replace(SELECTOR_GALLERY_SCOPE, '')).forEach((el) => set.add(el));
    });
    return Array.from(set);
  };

  const hasBadgeContent = (source) => {
    if (!source) return false;
    // xBadges가 실제로 badge HTML을 넣었는지 판단
    return source.children.length > 0 || (source.innerHTML && source.innerHTML.trim().length > 0);
  };

  const buildOverlay = (source) => {
    const wrap = document.createElement('div');
    wrap.className = OVERLAY_CLASS;
    wrap.setAttribute(OVERLAY_ATTR, '');
    wrap.setAttribute('aria-hidden', 'true');

    // clone: 모든 타겟에 동일한 뱃지를 유지해야 하므로 move가 아닌 clone
    wrap.appendChild(source.cloneNode(true));
    return wrap;
  };

  const ensureRelative = (el) => {
    // 이미 relative면 그대로
    const style = window.getComputedStyle(el);
    if (style.position === 'static') {
      el.style.position = 'relative';
    }
  };

  const clearExistingOverlay = (target) => {
    target.querySelectorAll(`[${OVERLAY_ATTR}]`).forEach((node) => node.remove());
  };

  const renderToAllTargets = () => {
    const scope = getScope();
    const source = getSource();
    if (!scope || !source) return;

    if (!hasBadgeContent(source)) return;

    const targets = getTargets(scope);
    if (!targets.length) return;

    targets.forEach((target) => {
      // 타겟 내부에 여러 레이어가 있을 수 있어서 매번 정리 후 1개만 주입
      clearExistingOverlay(target);
      ensureRelative(target);

      const overlay = buildOverlay(source);
      target.appendChild(overlay);
    });
  };

  const watchSourceChanges = () => {
    const source = getSource();
    if (!source) return;

    // 초기 렌더 (이미 로드된 경우 즉시)
    renderToAllTargets();

    // xBadges는 intersect/load 후 innerHTML을 교체하므로 감시 필요
    const mo = new MutationObserver(() => {
      // 너무 잦은 호출 방지를 위해 프레임 단위로 합치기
      window.requestAnimationFrame(() => {
        renderToAllTargets();
      });
    });

    mo.observe(source, { childList: true, subtree: true, characterData: true });

    // 섹션/미디어 갤러리 DOM이 재생성되는 경우 대비
    document.addEventListener('eurus:media-gallery-ready', () => {
      window.requestAnimationFrame(() => {
        renderToAllTargets();
      });
    });
  };

  const boot = () => {
    // 스코프와 소스가 늦게 생길 수 있어 약간의 재시도(가벼운 폴링, 짧게)
    let tries = 0;
    const maxTries = 20; // 20 * 150ms = 3초
    const timer = setInterval(() => {
      tries += 1;

      const scope = getScope();
      const source = getSource();

      if (scope && source) {
        clearInterval(timer);
        watchSourceChanges();
      } else if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();